// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".D36OkRFu{color:rgba(0,0,0,.5);font-size:2em;height:10em}@media(max-width:767.98px){.D36OkRFu{font-size:1.5em}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"empty": "D36OkRFu"
};
module.exports = ___CSS_LOADER_EXPORT___;
